import { formatCurrency, parseCurrency } from '@/lib/utils'

/** A debit or credit cell: blank when the line has nothing on that side, as journals print. */
export function journalMoney(amount: string): string {
  return parseCurrency(amount) === 0 ? '' : formatCurrency(amount)
}

/** How a journal entry's money moved (`card`, `cash`, `check`), as the page shows it. */
export function tenderLabel(tender: string): string {
  return tender.charAt(0).toUpperCase() + tender.slice(1).replaceAll('_', ' ')
}
